export default "__VITE_ASSET__CYh7g3Km__"